import { __cProductService } from '@/services/client/__c.product.service'
import { ProductFormatter } from '@/services/formatter/__f.product'
import { useQuery } from '@tanstack/react-query'

export function useProductWornTogether(productId: string) {
  return useQuery({
    queryKey: ['product-worn-together', productId],
    queryFn: () => __cProductService.getProductWornTogether(productId),
    enabled: !!productId,
    staleTime: 1000 * 60 * 5, // Cache data for 5 minutes
    refetchOnWindowFocus: false, // Prevent refetching on window focus
  })
}

export function useTechnologyBasedProducts(productId: string) {
  return useQuery({
    queryKey: ['technology-based-products', productId],
    queryFn: () => __cProductService.getTechnologyBasedProducts(productId),
    enabled: !!productId,
    staleTime: 1000 * 60 * 5, // Cache data for 5 minutes
    refetchOnWindowFocus: false, // Prevent refetching on window focus
  })
}

export function useProductVouchers(productId: string) {
  return useQuery({
    queryKey: ['product-vouchers', productId],
    queryFn: () => __cProductService.getProductVouchers(productId),
    enabled: !!productId,
    staleTime: 1000 * 60 * 5, // Cache data for 5 minutes
    refetchOnWindowFocus: false, // Prevent refetching on window focus
  })
}

export function useProductPromotions(productId: string) {
  return useQuery({
    queryKey: ['product-promotions', productId],
    queryFn: () => __cProductService.getProductPromotions(productId),
  })
}

export function useProductPricingPolicy(productId: string) {
  return useQuery({
    queryKey: ['product-pricing-policy', productId],
    queryFn: () => __cProductService.getProductPricingPolicy(productId),
    enabled: !!productId,
  })
}

export function useProductSuggestion(productId: string) {
  return useQuery({
    queryKey: ['product-suggestion', productId],
    queryFn: () => __cProductService.getProductSuggestion(productId),
    enabled: !!productId,
    refetchOnWindowFocus: false,
  })
}

export function useProductExtraFeatures(productId: string) {
  return useQuery({
    queryKey: ['product-extra-features', productId],
    queryFn: () => __cProductService.getProductExtraFeatures(productId),
    enabled: !!productId,
    refetchOnWindowFocus: false,
  })
}

export function useProductListByIds(ids: string[], limit?: number) {
  return useQuery({
    queryKey: ['product-list', ids, limit],
    queryFn: async () => {
      const res = await __cProductService.getProductsByIds(ids, limit)
      return ProductFormatter.reFormatProductResponse(res || [])
    },
    refetchOnWindowFocus: false,
  })
}
